__turbopack_context__.v({
  "expandable_toggle_button": "ExpandableText-module-scss-module__hQnANG__expandable_toggle_button",
  "expanded": "ExpandableText-module-scss-module__hQnANG__expanded",
});
